import React from 'react';
import { Spinner } from 'react-bootstrap';
import { ServicesContext } from '~/services';
import { enumValue } from '~/util';

export function LeadingReachIntegration() {
    const services = React.useContext(ServicesContext);
    const [loading, setLoading] = React.useState(false);
    const [updating, setUpdating] = React.useState(false);
    const lrLink = services.user.getExternalAccount('Core App');

    async function startLRLink() {
        setLoading(true);
        const result = await services.api.call({
            method: 'post',
            url: '/api/access-tokens',
            data: { type: enumValue(['user', 'tokens', 'Link Core App Account']) },
        });
        window.open(`${result.data.host}/user/zephyr-link/${result.data.token}`, '_blank');
        setLoading(false);
    }

    async function disableLRLink() {
        setLoading(true);
        await services.user.disableLRLink();
        setLoading(false);
        setUpdating(false);
    }

    function displayButtons() {
        if (updating) {
            return (
                <>
                    <button
                        className="btn btn-danger me-3"
                        type="button"
                        onClick={disableLRLink}
                        disabled={loading || !lrLink}
                    >
                        {loading && (
                            <Spinner
                                animation="border"
                                className="me-1"
                                role="status"
                                size="sm"
                                variant="light"
                            />
                        )}
                        Disable Link
                    </button>
                    <button
                        className="btn btn-secondary"
                        type="button"
                        onClick={() => setUpdating(false)}
                    >
                        Cancel
                    </button>
                </>
            );
        }
        if (lrLink) {
            return (
                <button className="btn btn-primary" type="button" onClick={() => setUpdating(true)}>
                    Update Link
                </button>
            );
        }
        return (
            <button
                className="btn btn-primary"
                type="button"
                onClick={startLRLink}
                disabled={loading || !!lrLink}
            >
                {loading && (
                    <Spinner
                        animation="border"
                        className="me-1"
                        role="status"
                        size="sm"
                        variant="light"
                    />
                )}
                Link Account
            </button>
        );
    }

    return (
        <>
            {!lrLink && (
                <div className="permissions-alert permissions-alert-card">
                    <span>
                        Not sure if you have a LeadingReach account?{' '}
                        <a
                            href="https://leadingreach.com/wellmed/pcp-leadingreach-access/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Click here
                        </a>{' '}
                        to request your account.
                    </span>
                </div>
            )}
            <div className="row align-items-center">
                <div className="col-3 text-end">LeadingReach</div>
                <div className="col-3">
                    {lrLink ? (
                        <>
                            <span className="me-2">Enabled</span>
                            <i
                                className="fa-solid fa-check-circle text-success"
                                title="Your LeadingReach account is linked to your Zephyr account"
                            />
                        </>
                    ) : (
                        <span>Off</span>
                    )}
                </div>
                <div className="col-6 text-end text-nowrap">{displayButtons()}</div>
                <div className="col-12 mt-3 text-center">
                    {updating && (
                        <span>
                            Are you sure? This will unlink your Zephyr account with LeadingReach.
                        </span>
                    )}
                </div>
            </div>
        </>
    );
}
